var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['header__button', { 'header__button--active': _vm.isShowMenu }],on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }